import { mediaList } from "@/mocks/media";
import { newsList } from "@/mocks/news";
import type { MediaItem, NewsItem } from "@/types/media";

export const allMedia = mediaList as MediaItem[];
export const allNews = newsList as NewsItem[];

export const getMediaById = (id: string): MediaItem | undefined =>
  allMedia.find((item) => item.id === id);